import angular from 'angular';
import AdvertisementComponent from './advertisement.component';

let AdvertisementModule = angular.module('home.advertisement',[])
    .component('advertisement',AdvertisementComponent);

export default AdvertisementModule;


/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shared/components/advertisement/advertisement.js
 **/